import { ClientCodes, ClientDomainType, ClientNames, VendorCodes } from '../enums';
import { BmoSettings, BridgeViewSettings, CenovusSettings, DemoClientSettings, DemoCorpSettings, DemoSettings, EySettings, FlextrackSettings, GorillaWorksSettings, HcmWorksSettings, JarvisSettings, KpmgSettings, ProcomSettings, ProcomTeamSettings, SoftchoiceSettings, SymbioticSettings } from './clients-settings';
export var SiteList = [
    {
        name: ClientNames.Procom,
        vendorCode: VendorCodes.PCGL,
        code: null,
        domains: [
            {
                hostname: 'portal.procomservices.com',
                authHostname: 'login.procomservices.com',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://login.procomservices.com',
                homepageAnonymousUsersUrl: 'https://portal.procomservices.com/jobs'
            },
            {
                hostname: 'procom-portal-dev.clientconnections.com',
                authHostname: 'procom-portal-dev-login.clientconnections.com',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://procom-portal-dev-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'procom-portal-uat.clientconnections.com',
                authHostname: 'procom-portal-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://procom-portal-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'procom-portal-qa.clientconnections.com',
                authHostname: 'procom-portal-qa-login.clientconnections.com',
                domainType: ClientDomainType.Qa,
                authPortalUrl: 'https://procom-portal-qa-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'localhost',
                authHostname: 'localhost',
                domainType: ClientDomainType.Local,
                authPortalUrl: 'http://localhost:8080',
                homepageAnonymousUsersUrl: null
            }
        ],
        settings: ProcomSettings
    },
    {
        name: ClientNames.BMO,
        code: ClientCodes.BMO,
        vendorCode: VendorCodes.PCGL,
        domains: [
            {
                hostname: 'bmo-portal.clientconnections.com',
                authHostname: 'bmo-login.clientconnections.com',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://bmo-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://bmo.clientconnections.com'
            },
            {
                hostname: 'bmo-portal-dev.clientconnections.com',
                authHostname: 'bmo-portal-dev-login.clientconnections.com',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://bmo-portal-dev-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'bmo-portal-qa.clientconnections.com',
                authHostname: 'bmo-portal-qa-login.clientconnections.com',
                domainType: ClientDomainType.Qa,
                authPortalUrl: 'https://bmo-portal-qa-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'bmo-portal-uat.clientconnections.com',
                authHostname: 'bmo-portal-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://bmo-portal-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            }
        ],
        settings: BmoSettings
    },
    {
        name: ClientNames.DemoCorp,
        code: ClientCodes.DemoCorp,
        vendorCode: VendorCodes.PCGL,
        domains: [
            {
                hostname: 'democorp-portal.clientconnections.com',
                authHostname: 'democorp-login.clientconnections.com',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://democorp-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://democorp.clientconnections.com'
            },
            {
                hostname: 'democorp-portal-dev.clientconnections.com',
                authHostname: 'democorp-portal-dev-login.clientconnections.com',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://democorp-portal-dev-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'democorp-portal-qa.clientconnections.com',
                authHostname: 'democorp-portal-qa-login.clientconnections.com',
                domainType: ClientDomainType.Qa,
                authPortalUrl: 'https://democorp-portal-qa-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'democorp-portal-uat.clientconnections.com',
                authHostname: 'democorp-portal-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://democorp-portal-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            }
        ],
        settings: DemoCorpSettings
    },
    {
        name: ClientNames.CENOVUS,
        code: ClientCodes.CENOVUS,
        vendorCode: VendorCodes.PCGL,
        domains: [
            {
                hostname: 'cenovus-portal.clientconnections.com',
                authHostname: 'cenovus-login.clientconnections.com',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://cenovus-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://cenovus.clientconnections.com'
            },
            {
                hostname: 'cenovus-portal-dev.clientconnections.com',
                authHostname: 'cenovus-portal-dev-login.clientconnections.com',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://cenovus-portal-dev-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'cenovus-portal-qa.clientconnections.com',
                authHostname: 'cenovus-portal-qa-login.clientconnections.com',
                domainType: ClientDomainType.Qa,
                authPortalUrl: 'https://cenovus-portal-qa-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'cenovus-portal-uat.clientconnections.com',
                authHostname: 'cenovus-portal-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://cenovus-portal-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            }
        ],
        settings: CenovusSettings
    },
    {
        name: ClientNames.KPMG,
        code: ClientCodes.KPMG,
        vendorCode: VendorCodes.PCGL,
        domains: [
            {
                hostname: 'kpmg-portal.clientconnections.com',
                authHostname: 'kpmg-login.clientconnections.com',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://kpmg-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://kpmg.clientconnections.com'
            },
            {
                hostname: 'kpmg-portal-dev.clientconnections.com',
                authHostname: 'kpmg-portal-dev-login.clientconnections.com',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://kpmg-portal-dev-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'kpmg-portal-qa.clientconnections.com',
                authHostname: 'kpmg-portal-qa-login.clientconnections.com',
                domainType: ClientDomainType.Qa,
                authPortalUrl: 'https://kpmg-portal-qa-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'kpmg-portal-uat.clientconnections.com',
                authHostname: 'kpmg-portal-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://kpmg-portal-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            }
        ],
        settings: KpmgSettings
    },
    {
        name: ClientNames.HCMWorks,
        code: ClientCodes.HCMWorks,
        vendorCode: VendorCodes.PCGL,
        domains: [
            {
                hostname: 'hcmworks-portal.clientconnections.com',
                authHostname: 'hcmworks-login.clientconnections.com',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://hcmworks-login.clientconnections.com',
                homepageAnonymousUsersUrl: null
            },
            {
                hostname: 'hcmworks-portal-dev.clientconnections.com',
                authHostname: 'hcmworks-portal-dev-login.clientconnections.com',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://hcmworks-portal-dev-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'hcmworks-portal-qa.clientconnections.com',
                authHostname: 'hcmworks-portal-qa-login.clientconnections.com',
                domainType: ClientDomainType.Qa,
                authPortalUrl: 'https://hcmworks-portal-qa-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'hcmworks-portal-uat.clientconnections.com',
                authHostname: 'hcmworks-portal-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://hcmworks-portal-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            }
        ],
        settings: HcmWorksSettings
    },
    {
        name: ClientNames.ProcomTeam,
        code: ClientCodes.ProcomTeam,
        vendorCode: VendorCodes.PCGL,
        domains: [
            {
                hostname: 'procominhouseteam-portal.clientconnections.com',
                authHostname: 'login.procomservices.com',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://procominhouseteam-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://procominhouseteam.clientconnections.com/jobs'
            },
            {
                hostname: 'procominhouseteam-portal-dev.clientconnections.com',
                authHostname: 'procominhouseteam-portal-dev-login.clientconnections.com',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://procominhouseteam-portal-dev-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'procominhouseteam-portal-qa.clientconnections.com',
                authHostname: 'procominhouseteam-portal-qa-login.clientconnections.com',
                domainType: ClientDomainType.Qa,
                authPortalUrl: 'https://procominhouseteam-portal-qa-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'procominhouseteam-portal-uat.clientconnections.com',
                authHostname: 'procominhouseteam-portal-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://procominhouseteam-portal-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            }
        ],
        settings: ProcomTeamSettings
    },
    {
        name: ClientNames.Flextrack,
        code: ClientCodes.Flextrack,
        vendorCode: VendorCodes.PCGL,
        domains: [
            {
                hostname: 'flextrack-portal.clientconnections.com',
                authHostname: 'flextrack-login.clientconnections.com',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://flextrack-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://flextrack.clientconnections.com/jobs'
            },
            {
                hostname: 'flextrack-portal-dev.clientconnections.com',
                authHostname: 'flextrack-portal-dev-login.clientconnections.com',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://flextrack-portal-dev-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'flextrack-portal-qa.clientconnections.com',
                authHostname: 'flextrack-portal-qa-login.clientconnections.com',
                domainType: ClientDomainType.Qa,
                authPortalUrl: 'https://flextrack-portal-qa-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'flextrack-portal-uat.clientconnections.com',
                authHostname: 'flextrack-portal-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://flextrack-portal-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            }
        ],
        settings: FlextrackSettings
    },
    {
        name: ClientNames.EY,
        code: ClientCodes.EY,
        vendorCode: VendorCodes.PCGL,
        domains: [
            {
                hostname: 'ey-portal.clientconnections.com',
                authHostname: 'ey-login.clientconnections.com',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://ey-login.clientconnections.com',
                homepageAnonymousUsersUrl: null
            },
            {
                hostname: 'ey-portal-dev.clientconnections.com',
                authHostname: 'ey-portal-dev-login.clientconnections.com',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://ey-portal-dev-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'ey-portal-qa.clientconnections.com',
                authHostname: 'ey-portal-qa-login.clientconnections.com',
                domainType: ClientDomainType.Qa,
                authPortalUrl: 'https://ey-portal-qa-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'ey-portal-uat.clientconnections.com',
                authHostname: 'ey-portal-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://ey-portal-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            }
        ],
        settings: EySettings
    },
    {
        name: ClientNames.Procom,
        code: ClientCodes.IMS,
        vendorCode: VendorCodes.PCGL,
        domains: [
            {
                hostname: 'ims.clientconnections.com',
                authHostname: 'ims-login.clientconnections.com',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://ims-login.clientconnections.com',
                homepageAnonymousUsersUrl: null
            },
            {
                hostname: 'ims-portal-uat.clientconnections.com',
                authHostname: 'ims-portal-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://ims-portal-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'ims-portal-qa.clientconnections.com',
                authHostname: 'ims-portal-qa-login.clientconnections.com',
                domainType: ClientDomainType.Qa,
                authPortalUrl: 'https://ims-portal-qa-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'ims-portal-dev.clientconnections.com',
                authHostname: 'ims-portal-dev-login.clientconnections.com',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://ims-portal-dev-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            }
        ],
        settings: ProcomSettings
    },
    {
        name: ClientNames.GorillaWorks,
        code: null,
        vendorCode: VendorCodes.GW,
        domains: [
            {
                hostname: 'portal.gorillaworks.io',
                authHostname: 'login.gorillaworks.io',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://login.gorillaworks.io',
                homepageAnonymousUsersUrl: null
            },
            {
                hostname: 'resume.gorillaworks.io',
                authHostname: 'login.gorillaworks.io',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://login.gorillaworks.io',
                homepageAnonymousUsersUrl: null
            },
            {
                hostname: 'gorillaworks-portal-dev.clientconnections.com',
                authHostname: 'gorillaworks-dev-login.clientconnections.com',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://gorillaworks-dev-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'gw-dev-resume-portal-web.azurewebsites.net',
                authHostname: 'gorillaworks-dev-login.clientconnections.com',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://gorillaworks-dev-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'gw-qa-resume-portal-web.azurewebsites.net',
                authHostname: 'gorillaworks-portal-qa-login.clientconnections.com',
                domainType: ClientDomainType.Qa,
                authPortalUrl: 'https://gorillaworks-portal-qa-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'gorillaworks-portal-uat.clientconnections.com',
                authHostname: 'gorillaworks-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://gorillaworks-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'gw-uat-resume-portal-web.azurewebsites.net',
                authHostname: 'gorillaworks-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://gorillaworks-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            }
        ],
        settings: GorillaWorksSettings
    },
    {
        name: ClientNames.GwDemoClient,
        code: ClientCodes.GwDemoClient,
        vendorCode: VendorCodes.GW,
        domains: [
            {
                hostname: 'gwdemo-portal.clientconnections.com',
                authHostname: 'gwdemo-login.clientconnections.com',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://gwdemo-login.clientconnections.com',
                homepageAnonymousUsersUrl: null
            },
            {
                hostname: 'gwdemo-portal-uat.clientconnections.com',
                authHostname: 'gwdemo-portal-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://gwdemo-portal-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: null
            },
            {
                hostname: 'gwdemo-portal-qa.clientconnections.com',
                authHostname: 'gwdemo-portal-qa-login.clientconnections.com',
                domainType: ClientDomainType.Qa,
                authPortalUrl: 'https://gwdemo-portal-qa-login.clientconnections.com',
                homepageAnonymousUsersUrl: null
            },
            {
                hostname: 'gwdemo-portal-dev.clientconnections.com',
                authHostname: 'gwdemo-portal-dev-login.clientconnections.com',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://gwdemo-portal-dev-login.clientconnections.com',
                homepageAnonymousUsersUrl: null
            }
        ],
        settings: GorillaWorksSettings
    },
    {
        name: ClientNames.Symbiotic,
        code: null,
        vendorCode: VendorCodes.Symbiotic,
        domains: [
            {
                hostname: 'symbiotic-portal.clientconnections.com',
                authHostname: 'symbiotic-login.clientconnections.com',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://symbiotic-login.clientconnections.com',
                homepageAnonymousUsersUrl: null
            },
            {
                hostname: 'symbiotic-portal-dev.clientconnections.com',
                authHostname: 'symbiotic-portal-dev-login.clientconnections.com',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://symbiotic-portal-dev-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'symbiotic-portal-qa.clientconnections.com',
                authHostname: 'symbiotic-portal-qa-login.clientconnections.com',
                domainType: ClientDomainType.Qa,
                authPortalUrl: 'https://symbiotic-portal-qa-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'symbiotic-portal-uat.clientconnections.com',
                authHostname: 'symbiotic-portal-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://symbiotic-portal-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            }
        ],
        settings: SymbioticSettings
    },
    {
        name: ClientNames.Softchoice,
        code: null,
        vendorCode: VendorCodes.SFTCHE,
        domains: [
            {
                hostname: 'softchoice-portal.clientconnections.com',
                authHostname: 'softchoice-login.clientconnections.com',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://softchoice-login.clientconnections.com',
                homepageAnonymousUsersUrl: null
            },
            {
                hostname: 'softchoice-portal-dev.clientconnections.com',
                authHostname: 'softchoice-portal-dev-login.clientconnections.com',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://softchoice-portal-dev-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'softchoice-portal-uat.clientconnections.com',
                authHostname: 'softchoice-portal-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://softchoice-portal-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            }
        ],
        settings: SoftchoiceSettings
    },
    {
        name: ClientNames.BridgeView,
        vendorCode: VendorCodes.BridgeView,
        code: null,
        domains: [
            {
                hostname: 'bridgeview-portal.gorillaworks.io',
                authHostname: 'bridgeview-login.gorillaworks.io',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://bridgeview-login.gorillaworks.io',
                homepageAnonymousUsersUrl: null
            },
            {
                hostname: 'bridgeview-portal-dev.gorillaworks.io',
                authHostname: 'bridgeview-portal-dev-login.gorillaworks.io',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://bridgeview-portal-dev-login.gorillaworks.io',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'bridgeview-portal-qa.gorillaworks.io',
                authHostname: 'bridgeview-portal-qa-login.gorillaworks.io',
                domainType: ClientDomainType.Qa,
                authPortalUrl: 'https://bridgeview-portal-qa-login.gorillaworks.io',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'bridgeview-portal-uat.gorillaworks.io',
                authHostname: 'bridgeview-portal-uat-login.gorillaworks.io',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://bridgeview-portal-uat-login.gorillaworks.io',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            }
        ],
        settings: BridgeViewSettings
    },
    {
        name: ClientNames.Jarvis,
        vendorCode: VendorCodes.Jarvis,
        code: null,
        domains: [
            {
                hostname: 'jarvis-visiontalent-portal.gorillaworks.io',
                authHostname: 'jarvis-visiontalent-login.gorillaworks.io',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://jarvis-visiontalent-login.gorillaworks.io',
                homepageAnonymousUsersUrl: null
            },
            {
                hostname: 'jarvis-visiontalent-portal-dev.gorillaworks.io',
                authHostname: 'jarvis-visiontalent-portal-dev-login.gorillaworks.io',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://jarvis-visiontalent-portal-dev-login.gorillaworks.io',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'jarvis-visiontalent-portal-qa.gorillaworks.io',
                authHostname: 'jarvis-visiontalent-portal-qa-login.gorillaworks.io',
                domainType: ClientDomainType.Qa,
                authPortalUrl: 'https://jarvis-visiontalent-portal-qa-login.gorillaworks.io',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'jarvis-visiontalent-portal-uat.gorillaworks.io',
                authHostname: 'jarvis-visiontalent-portal-uat-login.gorillaworks.io',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://jarvis-visiontalent-portal-uat-login.gorillaworks.io',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            }
        ],
        settings: JarvisSettings
    },
    {
        name: ClientNames.Demo,
        vendorCode: VendorCodes.DEMO,
        code: null,
        domains: [
            {
                hostname: 'demovendor-portal.clientconnections.com',
                authHostname: 'demovendor-login.clientconnections.com',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://demovendor-login.clientconnections.com',
                homepageAnonymousUsersUrl: null
            },
            {
                hostname: 'demovendor-portal-dev.clientconnections.com',
                authHostname: 'demovendor-portal-dev-login.clientconnections.com',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://demovendor-portal-dev-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'demovendor-portal-qa.clientconnections.com',
                authHostname: 'demovendor-portal-qa-login.clientconnections.com',
                domainType: ClientDomainType.Qa,
                authPortalUrl: 'https://demovendor-portal-qa-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'demovendor-portal-uat.clientconnections.com',
                authHostname: 'demovendor-portal-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://demovendor-portal-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            }
        ],
        settings: DemoSettings
    },
    {
        name: ClientNames.DemoClient,
        code: ClientCodes.DemoClient,
        vendorCode: VendorCodes.DEMO,
        domains: [
            {
                hostname: 'democlient-portal.clientconnections.com',
                authHostname: 'democlient-login.clientconnections.com',
                domainType: ClientDomainType.Production,
                authPortalUrl: 'https://democlient-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://democlient.clientconnections.com'
            },
            {
                hostname: 'democlient-portal-dev.clientconnections.com',
                authHostname: 'democlient-portal-dev-login.clientconnections.com',
                domainType: ClientDomainType.Develop,
                authPortalUrl: 'https://democlient-portal-dev-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'democlient-portal-qa.clientconnections.com',
                authHostname: 'democlient-portal-qa-login.clientconnections.com',
                domainType: ClientDomainType.Qa,
                authPortalUrl: 'https://democlient-portal-qa-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            },
            {
                hostname: 'democlient-portal-uat.clientconnections.com',
                authHostname: 'democlient-portal-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://democlient-portal-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: 'https://gw-portals-home.azurewebsites.net'
            }
        ],
        settings: DemoClientSettings
    },
    {
        name: ClientNames.DemoSandbox,
        code: null,
        vendorCode: VendorCodes.DEMOSANDBOX,
        domains: [
            {
                hostname: 'gwsandbox-portal-uat.clientconnections.com',
                authHostname: 'gwsandbox-portal-uat-login.clientconnections.com',
                domainType: ClientDomainType.Uat,
                authPortalUrl: 'https://gwsandbox-portal-uat-login.clientconnections.com',
                homepageAnonymousUsersUrl: null
            },
            {
                hostname: 'localhost',
                authHostname: 'localhost',
                domainType: ClientDomainType.Local,
                authPortalUrl: 'http://localhost:8060',
                homepageAnonymousUsersUrl: null
            }
        ],
        settings: GorillaWorksSettings
    }
];
